import { Select } from 'ui/select';

export interface AwardLogicOption {
  value: string;
  label: string;
}

export interface AwardLogicCellProps {
  value: string | null | undefined;
  options: AwardLogicOption[];
  onChange: (value: string) => void;
  'data-testid'?: string;
}

const AwardLogicCell = ({
  value,
  options,
  onChange,
  'data-testid': dataTestId = 'award-logic-cell',
}: AwardLogicCellProps) => {
  const selected = options.find((option) => option.value === value) ?? null;

  return (
    <Select
      options={options}
      value={selected ?? undefined}
      onChange={(option) => {
        if (option && !Array.isArray(option)) {
          onChange(String(option.value));
        }
      }}
      searchable={false}
      placeholder="Select..."
      aria-label="Awarding logic"
      size="medium"
      data-testid={dataTestId}
    />
  );
};

export default AwardLogicCell;
